<div *ngIf="!tripsLoading(); else loader" data-testid="upcoming-trips-list" class="flex flex--column">
  <ng-container *ngFor="let upcomingTrip of upcomingTrips$ | async">
    <fin-upcoming-trip
      [image]="upcomingTrip.arrival.location.picture"
      [departure]="upcomingTrip.departure.location.cityName"
      [arrival]="upcomingTrip.arrival.location.cityName"
      [departureDate]="upcomingTrip.departure.date"
      [bookingReference]="upcomingTrip.bookingReference"
      [lastName]="upcomingTrip.lastName"
      [remainingTrips]="upcomingTrip.remainingTrips"
      [checkForUpgradesTripLink]="checkForUpgradesTripLink"
      (viewDetailsClicked)="viewDetailsClick($event)"
    ></fin-upcoming-trip>
  </ng-container>
  <fcom-button
    class="flex-1 flex--basis0 see-all-trips-button"
    [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
    [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
    [mode]="ButtonMode.FILL"
    [text]="'MMB.upcomingTrips.tripsTab.button.seeAllTrips' | finLocalization"
    [href]="seeAllMyTripsLink$ | async"
  ></fcom-button>
</div>

<ng-template #loader>
  <div class="align-center loader" data-testid="upcoming-trips-loading">
    <div class="ps-xxsmall-b grey-600-text font-body-1" aria-live="assertive">
      <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT"></fcom-loader>
      {{ 'actions.loading' | finLocalization }}
    </div>
  </div>
</ng-template>
